import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { ModalConfirm } from '../../ModalConfirm';

interface IProps {
  isVisible: boolean;
  onConfirm(): void;
  onCancel(): void;
}

export function ModalRemove({ isVisible, onConfirm, onCancel }: IProps) {
  return (
    <ModalConfirm
      text="Удалить подборку?"
      onClose={onCancel}
      isVisible={isVisible}
      footer={
        <React.Fragment>
          <Button theme="fill_white_primary" size="XS" onClick={onCancel}>
            Отменить
          </Button>
          <Button size="XS" onClick={onConfirm}>
            Удалить
          </Button>
        </React.Fragment>
      }
    >
      <p>
        Объявления останутся в разделе <br /> “Все объявления” и других подборках
      </p>
    </ModalConfirm>
  );
}
